module.exports = __webpack_public_path__ + "img/mts.c42f1c50.svg";